module.exports = __webpack_public_path__ + "media/images/lig/icon-magnifying-glass-670470d060c6c0c1a3251907a2abd216.svg";